var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParques(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Parques",
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.339,
    height: 89.517,
    viewBox: "0 0 89.339 89.517",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #2d3539;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-1",
    d: "M226.058,30.348a14.761,14.761,0,0,0-17.427-18.454A16.751,16.751,0,1,0,178.456,25.72a1.748,1.748,0,0,0,2.944-1.874,13.259,13.259,0,1,1,24.244-9.453,1.748,1.748,0,0,0,2.324,1.332A11.263,11.263,0,0,1,222.3,30.546a1.748,1.748,0,0,0,.89,2.247,13.3,13.3,0,0,1,7.761,12.064,14.361,14.361,0,0,1-1.154,5.42,13.6,13.6,0,0,1-1.617,2.689,1.748,1.748,0,0,0,2.726,2.18,17.1,17.1,0,0,0,2.1-3.483,17.766,17.766,0,0,0,1.434-6.806,16.8,16.8,0,0,0-8.383-14.508Z",
    transform: "translate(-145.102 0.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-1",
    d: "M328.238,164.32V141.345h1.614a1.748,1.748,0,0,0,0-3.5h-8.715a16.191,16.191,0,0,0-11.525,4.773l-4.565,4.565V131.364l5.03-5.023a1.748,1.748,0,0,0-2.469-2.469l-2.561,2.556v-9.92a1.748,1.748,0,0,0-3.5,0v34.9a1.748,1.748,0,0,0,2.972,1.233l7.544-7.542a12.8,12.8,0,0,1,1.738-1.455v20.692a5.235,5.235,0,0,0,.374,10.455h13.973a5.235,5.235,0,1,0,.087-10.469Zm-10.931-22.394a12.851,12.851,0,0,1,3.829-.58h3.612v22.973h-7.441Zm10.84,29.372H314.19a1.748,1.748,0,1,1,0-3.5h13.96a1.748,1.748,0,1,1,0,3.5Z",
    transform: "translate(-248.829 -94.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-1",
    d: "M18.633,223.8a1.748,1.748,0,0,0-2.4.587l-.019.031a1.748,1.748,0,0,0,2.986,1.806l.019-.031A1.748,1.748,0,0,0,18.633,223.8Z",
    transform: "translate(-13.213 -184.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-1",
    d: "M66.98,180.714H56.221V160.958l5.985-5.985a1.748,1.748,0,1,0-2.469-2.467l-6.5,6.5a1.748,1.748,0,0,0-.511,1.234v20.478H50.18V147.045a1.748,1.748,0,0,0-.771-1.449l-5.174-3.479a13.916,13.916,0,0,0-.294-2.053h4.49a1.748,1.748,0,0,0,1.748-1.748V116.508a1.748,1.748,0,1,0-3.5,0v20.066H42.662a14.01,14.01,0,0,0-11.076-7.427A9.675,9.675,0,1,0,12.661,126.3a9.791,9.791,0,0,0,.135,1.621,14.511,14.511,0,0,0-3.9,1.315,1.748,1.748,0,0,0,1.573,3.117,11.03,11.03,0,0,1,4.64-1.178,1.748,1.748,0,0,0,1.546-2.434,6.186,6.186,0,1,1,10.7,1.171,1.748,1.748,0,0,0,1.628,2.752,10.467,10.467,0,0,1,11.791,10.41h0a10.4,10.4,0,0,1-3.252,7.588,1.748,1.748,0,0,0-.227,2.259,8.714,8.714,0,0,1-14.258,10.023v-3.306l4.413-4.411,4.2,2.3a1.748,1.748,0,1,0,1.673-3.061l-3.308-1.81,1.7-1.7a1.748,1.748,0,0,0-2.467-2.469l-3.322,3.322h0l-2.883,2.885V139.541a1.748,1.748,0,0,0-3.5,0V146.2L14,140.656a1.748,1.748,0,1,0-2.469,2.469l7.829,7.829a1.8,1.8,0,0,0,.187.159v7.8h0v3.252c-.01.017-.024.033-.033.051A8.548,8.548,0,1,1,6.491,151.564a1.748,1.748,0,0,0,.236-2.407,11,11,0,0,1-2.383-6.874,1.748,1.748,0,0,0-3.5,0,14.45,14.45,0,0,0,2.229,7.749,12.034,12.034,0,0,0,16.469,17.436v13.247H11.171a1.748,1.748,0,0,0,0,3.5H66.98a1.748,1.748,0,1,0,0-3.5Zm-20.3,0H23.035v-12.9a12.2,12.2,0,0,0,17.878-15.66,13.8,13.8,0,0,0,3.023-6.032l2.747,1.85Z",
    transform: "translate(-0.003 -94.694)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-1",
    d: "M223.328,37.227A10.249,10.249,0,0,0,213.09,47.464a1.748,1.748,0,1,0,3.5,0,6.754,6.754,0,0,1,6.747-6.747,1.748,1.748,0,1,0,0-3.5Z",
    transform: "translate(-175.835 -30.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M373.688,106.46a1.748,1.748,0,0,0,0,3.5,4.2,4.2,0,0,1,4.2,4.2,1.748,1.748,0,1,0,3.5,0A7.693,7.693,0,0,0,373.688,106.46Z",
    transform: "translate(-306.913 -87.845)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParques);
export default __webpack_public_path__ + "static/media/Parques.20615d4e27a56044a66407cb5c2f0909.svg";
export { ForwardRef as ReactComponent };